import { batchExportComponents } from '~/utils/helper.js'

import ConBox from '~/public/con-box/index.js'
import DSW from '~/public/dsw/index.js'
import ScrollBar from '~/public/scroll-bar/index.js'
import Verify from '~/public/verify/index.js'
import Auth from '~/public/auth/index.js'
import Slide from '~/public/slide/index.js'
import AttrOverlay from '~/public/attr-overlay/index.js'

// 导出组件
export {
    ConBox,
    DSW,
    ScrollBar,
    Verify,
    Auth,
    Slide,
    AttrOverlay
}

// 批量导出
export default batchExportComponents({
    ConBox,
    DSW,
    ScrollBar,
    Verify,
    Auth,
    Slide,
    AttrOverlay
})


// WEBPACK FOOTER //
// ./public/index.js